import React, { useState, useEffect } from 'react'
import { AiFillDelete } from 'react-icons/ai'
import { MdOutlineRemoveDone } from 'react-icons/md'
import axios from "axios";
import Swal from 'sweetalert2';
import ThingsListEnd from './ThingsListEnd';
import { ipAddress } from '../../ipAddress';


interface Props {
  shop: Shops
}
interface Shops {
  id: number,
  name: string,
  date: string,
  isDone: number,
}
interface Things {
  id: number,
  whatBuy: string,
  endDate: string,
  startDate: string,
  isDone: number,
  price: number,
}

const ShoppingListFinished: React.FC<Props> = ({ shop }) => {

  const [visibleList, setVisibleList] = useState<boolean>(false);
  const [thingsList, setThingsList] = useState<Things[]>([]);

  const handleDelete = (id: number) => {
    Swal.fire({
      title: 'Czy jesteś pewien?',
      text: "Element zostanie na zawsze usunięty!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
      heightAuto: false,

    }).then((result) => {
      if (result.isConfirmed) {
        axios.post(ipAddress + "/deleteShop", {
          id: id,
        })
        axios.post(ipAddress + "/deleteAllThings", {
          shopId: id,
        })
      }
    })
  }



  const handleDone = (id: number) => {
    
    Swal.fire({
      title: 'Czy jesteś pewien?',
      text: "Element zostanie przeniesiony do rzeczy do kupienia",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, move it!',
      heightAuto: false,

    }).then((result) => {
      if (result.isConfirmed) {
        axios.post(ipAddress + "/doneShop", {
          id: id,
          isDone: 0,
          date: '',
        })
      }
    })

      .then((response) => {

      })

      .catch(function (error) {
        console.log("error!")

      })
  }

  const getThingsList = () => {

    axios.post(ipAddress + "/getThingsList", {
      shopId: shop.id
    })
      .then((response) => {
        setThingsList(response.data)

      })
      .catch((err) => {
        console.log(err)
      })

  }
  useEffect(() => {
    getThingsList();


  }, [thingsList])


  return (
    <div>
      <div className='allShopsEnd'>
        <span id='text' onClick={() => setVisibleList(!visibleList)}>{shop.name}</span>
        <span className='icon' onClick={() => handleDone(shop.id)} ><MdOutlineRemoveDone /></span>
        <span className='icon' onClick={() => handleDelete(shop.id)}><AiFillDelete /></span>


      </div>
      {
        visibleList ? (
          thingsList.map((thing) => (
            <ThingsListEnd thing={thing} key={thing.id} />
          ))

        ) : (
          <div></div>
        )
      }
    </div>
  )
}

export default ShoppingListFinished